import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchProject } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

const formatDate = (iso) => {
  if (!iso) return "";
  return iso.substring(0, 10).replace(/-/g, "/");
};

export default function ProjectGoalListPage() {
  const { businessDomainId, businessUnitId, projectId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const basePath = `/strategy/${businessDomainId}/business-units/${businessUnitId}/projects/${projectId}`;

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const d = await fetchProject(projectId);
      setRows((d.goals || []).map((g, i) => ({ id: i, ...g })));
    } catch (e) { notify.apiError(e); }
    finally { setLoading(false); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  useEffect(() => { loadData(); }, [loadData]);

  const columns = [
    { field: "indicatorName", headerName: t("project.goal.indicator"), flex: 1, minWidth: 200,
      valueGetter: (v, row) => row?.indicator?.indicatorName || "" },
    { field: "plannedValue", headerName: t("project.goal.plannedValue"), width: 120 },
    { field: "unit", headerName: t("project.goal.unit"), width: 100,
      valueGetter: (v, row) => row?.indicator?.unit || "" },
    { field: "plannedDate", headerName: t("project.goal.plannedDate"), width: 120, valueFormatter: (v) => formatDate(v) },
    { field: "deadline", headerName: t("project.goal.deadline"), width: 120, valueFormatter: (v) => formatDate(v) },
  ];

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("project.goal.list.title")}</Typography>
        <Button variant="contained" startIcon={<AddIcon />}
          onClick={() => navigate(`${basePath}/goals/create`)}>{t("common.add")}</Button>
      </Box>
      <DataGrid
        rows={rows} columns={columns} getRowId={(r) => r.id}
        loading={loading} autoHeight pageSizeOptions={[10, 25, 50]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        onRowClick={(p) => navigate(`${basePath}/goals/${p.row.id}`)}
        disableRowSelectionOnClick sx={{ cursor: "pointer" }}
      />
      <Box sx={{ mt: 2 }}>
        <Button variant="outlined" onClick={() => navigate(basePath)}>{t("common.back")}</Button>
      </Box>
    </Box>
  );
}
